<script>
export default {
    
}
</script>

<template>
    <footer class="footer">
    <div class="container-fluid">
        <div class="row">
            <div>© {{ new Date().getFullYear()}} Nova Laboratories Sdn. Bhd. All Rights Reserved. Privacy Policy</div>
        </div>
    </div>
</footer>
</template>